import { render } from "./NavigationIcons.vue?vue&type=template&id=29e12598"
import script from "./NavigationIcons.vue?vue&type=script&lang=js"
export * from "./NavigationIcons.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__